import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Ng2SmartTableModule } from 'ng2-smart-table';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { SalesRoutingModule } from './sales-routing.module';
import { OrdersComponent } from './orders/orders.component';
import { OrdersitemComponent } from './ordersitem/ordersitem.component';
import { TransactionsComponent } from './transactions/transactions.component';

import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [OrdersComponent, TransactionsComponent,OrdersitemComponent],
  imports: [
    CommonModule,
    SalesRoutingModule,
    Ng2SmartTableModule,
    NgxDatatableModule,
    ReactiveFormsModule
  ]
})
export class SalesModule { }
